export const levelEnum = {
  OHS: "ohs",
  ADMIN: "admin",
  KONTRAKTOR: "kontraktor",
  ISAFE: "isafe",
  REPORTER: "reporter",
  ENVIRONMENT: "environment",
  IMPROVEMENT: "improvement",
  EXTERNAL: "external",
};

export const statusCOCEnum = {
  DRAFT: 0,
  UNDER_REVIEW: 1,
  NEED_REVISION: -3,
  DOCUMENT_COMPLETE: 2,
  NC_REVISION: 6,
  READY_TO_PUBLISH: 5,
  SURAT_PENGESAHAN_PJO_PUBLISHED: 7,
  UPDATE_DATA_KONTRAKTOR: 8,
  COC_PUBLISHED: 3,
  COC_EXPIRED: -4,
};

export const statusIMKPEnum = {
  DRAFT: 0,
  UNDER_REVIEW: 1,
  DOCUMENT_COMPLETE: 2,
  NEED_REVISION: 3,
  PENERBITAN_IMKP: 4,
  IMKP_PUBLISHED: 5,
  BAST_PROCESS: 6,
  BAST_REVISION: 7,
  IMKP_DONE: 8,
  BAST_WARRANTY: 9,
  BAST_WARRANTY_REVISION: 10,
};

export const StatusEnum = {
  DRAFT: "DRAFT",
  WAITING_APPROVAL: "WAITING APPROVAL",
  REVISION: "REVISION",
  REJECT: "REJECT",
  COMPLETED: "COMPLETED",
};

export const StatusEsgCommentEnum = {
  DRAFT: "DRAF",
  NEED_REVISION: "NEED REVISION",
  SOLVED: "SOLVED",
};

export const ActionEnum = {
  CREATE: "CREATE",
  UPDATE: "UPDATE",
  DELETE: "DELETE",
  ROLLBACK: "ROLLBACK",
};

export const TypeDataEnum = {
  EQUIPMENT: "EQUIPMENT",
  FUEL: "FUEL",
};

export const WorkAreaEnum = {
  MINING: "Mining",
  HAULING: "Hauling",
  PORT: "Port",
  OTHERS: "Others",
  PROJECT: "Project",
  BIB: "BIB",
};

export const TypeFileEnum = {
  ESG_REPORT: "esg-report",
  ESG_ELECTRIFICATION: "esg-electrification",
};

export const JenisNotifEsgEnum = {
  INPUTERS_SUBMIT: 1,
  PJO_APPROVE: 2,
  ADMIN_ROLLBACK: 3,
  ADMIN_SUBMIT: 4,
  PJO_REVISION: 5,
};

export const TypeSysConfigEnum = {
  CO2: "CO2",
  CH4: "CH4",
  N2O: "N2O",
};

export const IdFuelEnum = {
  BENSIN: 4,
};

export const TypeFormulaVersion = {
  V1: 1,
  V2: 2,
};

export const TypeChart = {
  FUEL: "FUEL",
  ENERGY: "ENERGY",
  EMISSION_TON: "EMISSION TON",
};

export const TypeModeApp = {
  DEVELOPMENT: "dev",
  PRODUCTION: "prod",
};

export const StatusIdDocument = {
  DRAFT: 0,
  ON_PROGRESS: 1,
  COMPLETED: 99,
};

export const StatusIdNC = {
  OPEN: 1,
  UNDER_REVIEW_PJO: 2,
  UNDER_REVIEW: 3,
  REVISION: 98,
  APPROVED: 99,
};

export const StatusIdPJP = {
  SELF_ASSESSMENT: 1,
  PENILAIAN_EVALUATOR: 2,
  WAITING_COMPLIANCE_APPROVAL: 3,
  NC_REVIEW_COMPLIANCE: 4,
  NC_ON_PROGRESS: 5,
  COMPLETED: 99,
};

export const StatusAssessmentEvaluatorEnum = {
  EVALUATION_ON_PROGRESS: 1,
  SCORE_REVIEW_COMPLIANCE: 2,
  SCORE_RELEASED: 3,
  NC_REVIEW_COMPLIANCE: 4,
  NC_RELEASED: 5,
};

export const StatusEvidence = {
  OPEN: "OPEN",
  REVISION: "REJECT",
  APPROVED: "APPROVE",
};

export const TypeClassification = {
  MAYOR: "Mayor",
  MINOR: "Minor",
  KRITIKAL: "Kritikal",
  OBSERVATION: "Observation",
};

export const CategoryNC = {
  SMKP: "SMKP",
  PJP: "PJP",
};
